"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function assert(condition, message = "assertion failed") {
    if (!condition) {
        throw new Error(message);
    }
}
exports.assert = assert;
function invariant(condition, message = "invariant failed") {
    if (!condition) {
        throw new Error(message);
    }
}
exports.invariant = invariant;
function unreachable(message = "this code is unreachable") {
    throw new Error(message);
}
exports.unreachable = unreachable;
function assertDefined(value, message) {
    assert(value, (message !== null && message !== void 0 ? message : `Value should not be undefined or null but is ${value}.`));
    return value;
}
exports.assertDefined = assertDefined;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzZXJ0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWwvYXNzZXJ0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsU0FBZ0IsTUFBTSxDQUNsQixTQUFrQixFQUNsQixPQUFPLEdBQUcsa0JBQWtCO0lBRTVCLElBQUksQ0FBQyxTQUFTLEVBQUU7UUFDWixNQUFNLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFBO0tBQzNCO0FBQ0wsQ0FBQztBQVBELHdCQU9DO0FBRUQsU0FBZ0IsU0FBUyxDQUNyQixTQUFrQixFQUNsQixPQUFPLEdBQUcsa0JBQWtCO0lBRTVCLElBQUksQ0FBQyxTQUFTLEVBQUU7UUFDWixNQUFNLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFBO0tBQzNCO0FBQ0wsQ0FBQztBQVBELDhCQU9DO0FBRUQsU0FBZ0IsV0FBVyxDQUFDLE9BQU8sR0FBRywwQkFBMEI7SUFDNUQsTUFBTSxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQTtBQUM1QixDQUFDO0FBRkQsa0NBRUM7QUFFRCxTQUFnQixhQUFhLENBQ3pCLEtBQTJCLEVBQzNCLE9BQWdCO0lBRWhCLE1BQU0sQ0FDRixLQUFLLEdBQ0wsT0FBTyxhQUFQLE9BQU8sY0FBUCxPQUFPLEdBQUksZ0RBQWdELEtBQUssR0FBRyxFQUN0RSxDQUFBO0lBQ0QsT0FBTyxLQUFLLENBQUE7QUFDaEIsQ0FBQztBQVRELHNDQVNDIn0=